<mat-card class="card">
    <card-header title="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.TITLE' | translate }}">
    </card-header>
    <definition-list>
        <definition-item *ngIf="subject?.cpsuStatus" key="{{ 'GLOBAL.SUBJECT.STATUS_CPSU' | translate }}">
            <status-label status="{{subject?.cpsuStatus=='ACTIVE'?1:2}}">
                {{ subject?.cpsuStatus!==''?('GLOBAL.SUBJECT.CPSU_STATUS_'+subject?.cpsuStatus | translate):'' }}
            </status-label></definition-item>
        <definition-item *ngIf="subject?.csrStatus" key="{{ 'GLOBAL.SUBJECT.STATUS_CSR' | translate }}">
            <status-label status="{{subject?.csrStatus=='АКТИВАН'?1:2}}">
                {{ subject?.csrStatus }}
            </status-label></definition-item>
        <definition-item *ngIf="subject?.registrationId" key="{{ 'GLOBAL.SUBJECT.REGISTRATION_ID' | translate }}">
            {{ subject?.registrationId }}</definition-item>
        <definition-item *ngIf="subject?.firstName" key="{{ 'GLOBAL.SUBJECT.FIRST_AND_LAST_NAME' | translate }}">
            {{ subject?.firstName }} {{ subject?.lastName }}</definition-item>
        <definition-item *ngIf="subject?.parentName" key="{{ 'SUBJECTS.PARENTNAME' | translate }}">
            {{ subject?.parentName }}</definition-item>
        <definition-item *ngIf="subject?.gender" key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.GENDER' | translate }}">
            {{ subject?.gender }}
        </definition-item>
        <definition-item *ngIf="subject?.dateOfBirth"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.DATE_OF_BIRTH' | translate }}">
            {{ subject?.dateOfBirth| date: 'dd.MM.yyyy.' }}
        </definition-item>
        <definition-item *ngIf="subject?.yearOfBirth"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.YEAR_OF_BIRTH' | translate }}">
            {{ subject?.yearOfBirth }}
        </definition-item>
        <definition-item *ngIf="subject?.jmbg && subject?.foreigner!==true"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.JMBG' | translate }}">
            {{ subject?.jmbg }}</definition-item>
        <definition-item *ngIf="subject?.jmbg && subject?.foreigner===true"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.EBS' | translate }}">
            {{ subject?.jmbg }}</definition-item>
        <definition-item *ngIf="subject?.placeOfBirth"
            key="{{'NEW_SUBJECT.PERSONAL_DETAILS.PLACE_OF_BIRTH' | translate}}">{{
            subject?.placeOfBirth
            }}</definition-item>
        <definition-item *ngIf="subject?.nationality"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.NATIONALITY' | translate }}">
            {{ subject?.nationality }}
        </definition-item>
        <definition-item *ngIf="subject?.citizenship"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.CITIZENSHIP' | translate }}">
            {{ subject?.citizenship }}
        </definition-item>
        <definition-item *ngIf="subject?.category" key="{{ 'GLOBAL.SUBJECT.CATEGORY_OF_PERSON' | translate }}">
            {{ subject?.category }}
        </definition-item>
        <definition-item *ngIf="subject?.language"
            key="{{'NEW_SUBJECT.PERSONAL_DETAILS.NATIVE_LANGUAGE' | translate}}">{{
            subject?.language
            }}</definition-item>
        <definition-item-divider *ngIf="showDivider"></definition-item-divider>
        <definition-item *ngIf="subject?.disabledPerson !== null"
            key="{{'NEW_SUBJECT.PERSONAL_DETAILS.DISABLED_PERSON' | translate}}">
            {{ (subject?.disabledPerson ? 'GLOBAL.YES' : 'GLOBAL.NO') | translate }} </definition-item>
        <definition-item *ngIf="subject?.disabilityType"
            key="{{'NEW_SUBJECT.PERSONAL_DETAILS.DISABILITY_TYPE' | translate}}">{{
            subject?.disabilityType
            }}</definition-item>
        <definition-item *ngIf="subject?.ableToWork !== null"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.ABLE_TO_WORK' | translate }}">
            {{ (subject?.ableToWork ? 'GLOBAL.YES' : 'GLOBAL.NO') | translate }}
        </definition-item>
        <definition-item *ngIf="subject?.occupation" key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.OCCUPATION' | translate }}">
            {{ subject?.occupation }}</definition-item>
        <definition-item *ngIf="subject?.employment" key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.EMPLOYMENT' | translate }}">
            {{ subject?.employment }}</definition-item>
        <definition-item *ngIf="subject?.education" key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.EDUCATION' | translate }}">
            {{ subject?.education }}
        </definition-item>
        <definition-item *ngIf="subject?.levelOfEducation"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.LEVEL_OF_EDUCATION' | translate }}">
            {{ subject?.levelOfEducation }}
        </definition-item>
        <definition-item *ngIf="subject?.schoolAttending"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.SCHOOL_ATTENDING' | translate }}">
            {{ subject?.schoolAttending }}
        </definition-item>
        <definition-item *ngIf="subject?.businessAbility !== null"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.BUSINESS_ABILITY' | translate }}">
            {{ (subject?.businessAbility ? 'GLOBAL.YES' : 'GLOBAL.NO') | translate }}
        </definition-item>
        <definition-item *ngIf="subject?.deprivationExtent"
            key="{{'NEW_SUBJECT.PERSONAL_DETAILS.DEPTIVATION_EXTENT' | translate}}">{{
            subject?.deprivationExtent }}</definition-item>
        <definition-item *ngIf="subject?.maritalStatus"
            key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.MARITAL_STATUS' | translate }}">
            {{ subject?.maritalStatus }}
        </definition-item>
    </definition-list>
    <card-subgroup-divider></card-subgroup-divider>
    <card-header title="{{ 'NEW_SUBJECT.ADDRESS.TITLE' | translate }}"></card-header>
    <definition-list>
        <definition-item *ngIf="subject?.permanentResidence && subject?.permanentResidence !== ''"
            key="{{ 'GLOBAL.SUBJECT.ORIGIN_ADDRESS_FULL' | translate }}"><span style="white-space: pre-wrap;">{{
                subject?.permanentResidence }}</span>
        </definition-item>
        <definition-item *ngIf="subject?.residence && subject?.residence !== ''"
            key="{{ 'GLOBAL.SUBJECT.RESIDENCE_ADDRESS_FULL' | translate }}"><span style="white-space: pre-wrap;">{{
                subject?.residence }}</span>
        </definition-item>
        <definition-item *ngIf="subject?.phone" key="{{ 'NEW_SUBJECT.ADDRESS.PHONE' | translate }}">
            {{ subject?.phone }}</definition-item>
        <definition-item *ngIf="subject?.mobile" key="{{ 'NEW_SUBJECT.ADDRESS.MOBILE' | translate }}">
            {{ subject?.mobile }}</definition-item>
        <definition-item *ngIf="subject?.email" key="{{ 'NEW_SUBJECT.ADDRESS.EMAIL' | translate }}">
            {{ subject?.email }}
        </definition-item>
    </definition-list>
    <card-subgroup-divider></card-subgroup-divider>

    <card-header title="{{ 'NEW_SUBJECT.FAMILY.TITLE' | translate }}"></card-header>
    <definition-list>
        <definition-item *ngIf="subject?.familyDossier" key="{{ 'NEW_SUBJECT.FAMILY.FAMILY_DOSSIER' | translate }}">
            {{ familyDossier }}
        </definition-item>
        <definition-item *ngIf="subject?.jmbp" key="{{ 'NEW_SUBJECT.FAMILY.JMBP' | translate }}">
            {{ subject?.jmbp }}
        </definition-item>
        <definition-item *ngIf="subject?.familyType" key="{{ 'NEW_SUBJECT.PERSONAL_DETAILS.FAMILY_TYPE' | translate }}">
            {{ subject?.familyType }}
        </definition-item>
    </definition-list>
    <card-subgroup-divider></card-subgroup-divider>

    <card-header title="{{ 'NEW_SUBJECT.OTHER.TITLE' | translate }}">
    </card-header>
    <definition-list>
        <definition-item *ngIf="subject?.note" key="{{ 'NEW_SUBJECT.OTHER.NOTE' | translate }}">
            {{ subject?.note }}
        </definition-item>
        <definition-item *ngIf="subject?.note1" key="{{ 'NEW_SUBJECT.OTHER.NOTE1' | translate }}">
            {{ subject?.note1 }}
        </definition-item>
        <definition-item *ngIf="subject?.note2" key="{{ 'NEW_SUBJECT.OTHER.NOTE2' | translate }}">
            {{ subject?.note2 }}
        </definition-item>
        <definition-item *ngIf="subject?.note3" key="{{ 'NEW_SUBJECT.OTHER.NOTE3' | translate }}">
            {{ subject?.note3 }}
        </definition-item>
        <definition-item *ngIf="subject?.csrName" key="{{ 'GLOBAL.CENTER' | translate }}">
            {{ subject?.csrName }}
        </definition-item>
        <definition-item *ngIf="subject?.csrDossierOwner" key="{{'NEW_SUBJECT.OTHER.CSR_DOSSIER_OWNER' | translate}}">
            {{ subject?.csrDossierOwner }}
        </definition-item>
        <definition-item *ngIf="subject?.cpsuDossierOwner" key="{{'NEW_SUBJECT.OTHER.CPSU_DOSSIER_OWNER' | translate}}">
            {{ subject?.cpsuDossierOwner }}
        </definition-item>
        <definition-item *ngIf="subject && subject.isFosterParent != null && subject.isFosterParent != undefined"
            key="{{'NEW_SUBJECT.OTHER.SUBJECT_TYPE' | translate}}">
            {{ (subject?.isFosterParent ? 'CASES.CPSU.FOSTER_PARENT':'CASES.CPSU.FOSTER_CHILD') | translate }}
        </definition-item>
        <definition-item *ngIf="subject?.dateOfCreation" key="{{ 'NEW_SUBJECT.OTHER.DATE_OF_CREATION' | translate }}">
            {{ subject?.dateOfCreation | date: 'dd.MM.yyyy.' }}
        </definition-item>
        <definition-item *ngIf="subject?.modifiedBy" key="{{ 'SUBJECT_DETAILS.MODIFIED_BY' | translate }}">
            {{ subject?.modifiedBy }}
        </definition-item>
        <definition-item *ngIf="subject?.dateOfModification" key="{{ 'SUBJECTS.DATEOFMODIFICATION' | translate }}">
            {{ subject?.dateOfModification | date: 'dd.MM.yyyy.'}}
        </definition-item>
    </definition-list>
</mat-card>
<app-foster-family [members]="members">
</app-foster-family>